var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleWarning = function SvgCircleWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m-.8-7.2a.8.8 0 0 0 1.6 0V4a.8.8 0 1 0-1.6 0zm.8 1.6a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4",
    clipRule: "evenodd"
  })));
};
export default SvgCircleWarning;